import { Box, Typography } from "@mui/material"

export function SummaryCard({ label, value, color }) {
    return (
        <Box sx={{ textAlign: "center", minWidth: 80 }}>
            <Typography variant="h5" sx={{ color: color || "text.primary" }}>
                {value ?? 0}
            </Typography>
            <Typography variant="caption" color="text.secondary">
                {label}
            </Typography>
        </Box>
    )
}
